// extracted by mini-css-extract-plugin
export var lista = "styles-module--lista--KKTRZ";
export var legenda = "styles-module--legenda--27whl";
export var legendaValor = "styles-module--legendaValor--1lXNO";
export var legendaNome = "styles-module--legendaNome--qRcWD";